import React from 'react'
import PropTypes from 'prop-types'
import { Modal } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

import {
  StyledWrapper,
  StyledWrapIcon,
} from './SideBarModal.styled';

const SideBarModal = props => {
  const { open, handleClose, children } = props;
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
    >
      <div>
        <StyledWrapper>
          {children}
        </StyledWrapper>
        <StyledWrapIcon onClick={handleClose}>
          <CloseIcon />
        </StyledWrapIcon>
      </div>
    </Modal>
  )
}

SideBarModal.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  children: PropTypes.node.isRequired,
}

SideBarModal.defaultProps = {
  open: false,
  handleClose: () => {},
}

export default SideBarModal
